import {Component} from "@angular/core";

@Component({
  selector: "ui-prompt-footer",
  templateUrl: "./prompt-footer.component.html",
  styleUrls: ["./prompt-footer.component.scss"],
})
export class PromptFooterComponent {}
